export const passkeyInterstitialViewStringsDefaultFabric = {
  title: getLocalString("SignIn_FaceFingerprintPin"),
  description: getLocalString("PasskeySignin_FaceFingerprintPin"),
  nextLabel: getLocalString("General_Buttons_Next"),
};

export type PasskeyInterstitialViewStringsFabric =
  typeof passkeyInterstitialViewStringsDefaultFabric;
